(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $ff37988fb95e3900$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("1CUfz"), JSON.parse('["1CUfz","index.ff8e23b9.js","7C6ft","../Karappo.c6893bef.mp3"]'));

// Autrona Acoustic Computer Kernel Module: Audio
// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.
var $023aab51a0ce09ef$exports = {};

$parcel$export($023aab51a0ce09ef$exports, "load", function () { return $023aab51a0ce09ef$export$11e63f7b0f3d9900; });
$parcel$export($023aab51a0ce09ef$exports, "play", function () { return $023aab51a0ce09ef$export$899fbdb5fa08b653; });
$parcel$export($023aab51a0ce09ef$exports, "audioBuffers", function () { return $023aab51a0ce09ef$export$c2a342ec653dfb48; });
// Audio kernel module: Buffer
// Manages loading, decoding and plaback of audioBuffers

// References
const $023aab51a0ce09ef$export$c2a342ec653dfb48 = {};
function $023aab51a0ce09ef$export$11e63f7b0f3d9900(name, url, progress = null) {
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject)=>{
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        request.onload = ()=>{
            resolve($023aab51a0ce09ef$var$decode(name, request.response));
        };
        request.onerror = ()=>{
            reject();
            console.error(`An error occured while getting '${name}' audio from '${url}'`);
        };
        request.onprogress = (e)=>{
            const percent = Math.round(e.loaded / e.total * 100);
            if (typeof progress === "function") progress(percent);
            if (DEVMODE) console.log(`Progress loading '${name}' audio file`, percent + "%");
        };
        request.send();
    });
    return promise;
}
function $023aab51a0ce09ef$var$decode(name, arrayBuffer) {
    const promise = new Promise((resolve, reject)=>{
        $2044bad78f9935e8$export$a078c61943f9dbbe.decodeAudioData(arrayBuffer, (buffer)=>{
            $023aab51a0ce09ef$export$c2a342ec653dfb48[name] = buffer;
            resolve();
            if (DEVMODE) console.log(`Decoded '${name}' audio buffer`);
        }, (e)=>{
            reject();
            console.error("Error while decoding audio data: " + e);
        });
    });
    return promise;
}
function $023aab51a0ce09ef$export$899fbdb5fa08b653(name, options = {}) {
    if ($023aab51a0ce09ef$export$c2a342ec653dfb48[name] === undefined) {
        console.error(`Play error: '${name}' audio buffer does not exist.`);
        return false;
    }
    $2044bad78f9935e8$export$fbb4d68fe60c1629();
    // Create a new source
    const source = $2044bad78f9935e8$export$a078c61943f9dbbe.createBufferSource();
    const gainNode = $2044bad78f9935e8$export$a078c61943f9dbbe.createGain();
    if (options.initialGain != undefined) // Note: this initial gain value will only be applied after that time
    // have passed (it does not change immediately).
    gainNode.gain.setValueAtTime($2044bad78f9935e8$export$33ed28de027e9482(options.initialGain), $2044bad78f9935e8$export$a078c61943f9dbbe.currentTime);
    source.gainNode = gainNode; // custom property for reference
    source.fadeTo = $2044bad78f9935e8$export$549ee30ac73cf40b; // custom function
    source.fade = $2044bad78f9935e8$export$cbea29d068a2e18f; // custom function
    source.connect(gainNode);
    gainNode.connect(options.destination || $2044bad78f9935e8$export$a078c61943f9dbbe.destination);
    // Optional looping parameters
    source.loop = options.loop || false;
    source.loopStart = options.loopStart || 0;
    source.loopEnd = options.loopEnd || 0;
    // Optional starting parameters
    const when = (options.when || 0) + $2044bad78f9935e8$export$a078c61943f9dbbe.currentTime;
    const offset = options.offset || 0;
    const duration = options.duration || undefined;
    // ... more options to come (detune, playBackRate)?
    // Assign an already loaded and decoded buffer
    source.buffer = $023aab51a0ce09ef$export$c2a342ec653dfb48[name];
    // On ended event
    source.onended = ()=>{
        if (typeof options.onended === "function") options.onended();
        $2044bad78f9935e8$export$93c25f2590a5b540(source);
    };
    // Start producing sound
    if (options.defer === undefined) source.start(when, offset, duration);
    // Maintain references to this source
    $2044bad78f9935e8$export$d1d41f0cda037248.push(source);
    return source;
}


// References
let $2044bad78f9935e8$export$a078c61943f9dbbe;
const $2044bad78f9935e8$export$d1d41f0cda037248 = [];
function $2044bad78f9935e8$export$2cd8252107eb640b() {
    // Create AudioContext
    if (typeof AudioContext !== "undefined") $2044bad78f9935e8$export$a078c61943f9dbbe = new AudioContext();
    else // For Safari
    $2044bad78f9935e8$export$a078c61943f9dbbe = new webkitAudioContext();
    if (DEVMODE) console.log("Audio context sample rate: " + $2044bad78f9935e8$export$a078c61943f9dbbe.sampleRate);
}
function $2044bad78f9935e8$export$fbb4d68fe60c1629() {
    // Resume context, dealing with autoplay policy
    if ($2044bad78f9935e8$export$a078c61943f9dbbe.state === "suspended") {
        if (DEVMODE) console.log("Resuming AudioContext");
        return $2044bad78f9935e8$export$a078c61943f9dbbe.resume();
    } else return Promise.resolve();
}
// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function $2044bad78f9935e8$export$549ee30ac73cf40b(time = 2, level = 0, fromLevel = -90, mode = "linear") {
    this.gainNode.gain.setValueAtTime($2044bad78f9935e8$export$33ed28de027e9482(fromLevel), $2044bad78f9935e8$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime($2044bad78f9935e8$export$33ed28de027e9482(level), $2044bad78f9935e8$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime($2044bad78f9935e8$export$33ed28de027e9482(level), $2044bad78f9935e8$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function $2044bad78f9935e8$export$cbea29d068a2e18f(time = 2, db = -90, andStop = false, mode = "linear") {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, $2044bad78f9935e8$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime(currentGain * $2044bad78f9935e8$export$33ed28de027e9482(db), $2044bad78f9935e8$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime(currentGain * $2044bad78f9935e8$export$33ed28de027e9482(db), $2044bad78f9935e8$export$a078c61943f9dbbe.currentTime + time);
    if (andStop) this.stop($2044bad78f9935e8$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
function $2044bad78f9935e8$export$51b36263b660c3ee(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    $2044bad78f9935e8$export$d1d41f0cda037248.forEach((s)=>s.fade(time, finalGain, true));
}
function $2044bad78f9935e8$export$33390c3a9a83a2f() {
    $2044bad78f9935e8$export$d1d41f0cda037248.forEach((s)=>s.stop());
}
function $2044bad78f9935e8$export$93c25f2590a5b540(source) {
    const index = $2044bad78f9935e8$export$d1d41f0cda037248.indexOf(source);
    $2044bad78f9935e8$export$d1d41f0cda037248.splice(index, 1);
}
function $2044bad78f9935e8$export$e2eaa0ea75f89eaa(gain) {
    return 20 * log10(gain);
    function log10(x) {
        return Math.log(x) / Math.LN10;
    }
}
function $2044bad78f9935e8$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}




function $52e181852859a5f5$export$2cd8252107eb640b() {
    document.querySelector(".js-start").addEventListener("click", ()=>{
        if (DEVMODE) console.log("Starting...");
        document.querySelector(".js-start").classList.add("hidden");
        document.querySelector(".center").classList.add("hidden");
        document.querySelector(".screen").classList.remove("hidden");
        $2044bad78f9935e8$export$fbb4d68fe60c1629().then(()=>{
            $42c1f3c961046928$export$b3571188c770cc5a();
        });
    });
}
function $52e181852859a5f5$export$471f7ae5c4103ae1(status) {
    const statusEl = document.querySelector("#status");
    if (status === null) statusEl.classList.add("hidden");
    else statusEl.classList.remove("hidden");
    statusEl.innerText = status;
}
function $52e181852859a5f5$export$4bb981a91e4f02eb() {
    document.querySelector(".js-start").classList.remove("hidden");
    $52e181852859a5f5$export$471f7ae5c4103ae1(null);
}



var $fec9037ce3868b11$exports = {};

$fec9037ce3868b11$exports = (parcelRequire("aNJCr")).getBundleURL("1CUfz") + "../Karappo.c6893bef.mp3";


const $caf37357c58d053a$var$sounds = [
    {
        name: "karappo",
        url: new URL($fec9037ce3868b11$exports)
    }
];
function $caf37357c58d053a$export$2cd8252107eb640b() {
    return $caf37357c58d053a$var$loadSounds();
}
function $caf37357c58d053a$var$loadSounds() {
    return Promise.all([
        ...$caf37357c58d053a$var$sounds.map((sound)=>{
            return $023aab51a0ce09ef$exports.load(sound.name, sound.url);
        })
    ]).then(()=>{
        if (DEVMODE) console.log("All sounds loaded");
    });
}



const $0cb3818ba656ff38$var$MARK = "\xa7";
let $0cb3818ba656ff38$var$karaokeText;
const $0cb3818ba656ff38$var$timeouts = [];
const $0cb3818ba656ff38$var$karaokeData = [
    {
        "bar": 2,
        "txt": "\xa7[une voix qui s\u2019excuse]"
    },
    {
        "bar": 4,
        "txt": ""
    },
    {
        "bar": 5,
        "txt": "\xa7[une voix narrative]"
    },
    {
        "bar": 6,
        "txt": ""
    },
    {
        "bar": 7,
        "txt": "\xa7[le piano se ferme]"
    },
    {
        "bar": 8,
        "txt": ""
    },
    {
        "bar": 9,
        "txt": "\xa7[les bois, les cuivres se retirent]"
    },
    {
        "bar": 10,
        "txt": ""
    },
    {
        "bar": 11,
        "txt": "\xa7[les percussions s\u2019en vont]"
    },
    {
        "bar": 12,
        "txt": ""
    },
    {
        "bar": 13,
        "txt": "\xa7[les cordes se dispersent]"
    },
    {
        "bar": 14,
        "txt": ""
    },
    {
        "bar": 15,
        "txt": "\xa7[les premiers violons<br>sont d\xe9j\xe0 \xe0 l\u2019h\xf4tel]"
    },
    {
        "bar": 16,
        "txt": ""
    },
    {
        "bar": 17,
        "txt": "\xa7[je suis second]"
    },
    {
        "bar": 18,
        "txt": ""
    },
    {
        "bar": 19,
        "txt": "\xa7[la voix qui s\u2019excuse dispara\xeet]"
    },
    {
        "bar": 20,
        "txt": ""
    },
    {
        "bar": 21,
        "txt": "\xa7[c\u2019est \xe0 vous je crois]"
    },
    {
        "bar": 22,
        "txt": ""
    },
    {
        "bar": 23,
        "txt": "\xa7[\xe0 vous]"
    },
    {
        "bar": 24,
        "txt": ""
    },
    {
        "bar": 25,
        "txt": "Main droite\xa7 la ligne"
    },
    {
        "bar": 26,
        "txt": "D'horizon\xa7 s'affine"
    },
    {
        "bar": 27,
        "txt": "Des villes-\xa7violons"
    },
    {
        "bar": 28,
        "txt": "Dehors\xa7 ils sont"
    },
    {
        "bar": 29,
        "txt": "Pench\xe9s\xa7 \xe0 peine"
    },
    {
        "bar": 30,
        "txt": "Peuvent-ils\xa7 se perdre ?"
    },
    {
        "bar": 31,
        "txt": "La nuit\xa7 les prend"
    },
    {
        "bar": 32,
        "txt": "en ti\xa7tubant"
    },
    {
        "bar": 33,
        "txt": "Main droite\xa7 la ville"
    },
    {
        "bar": 34,
        "txt": "Des an\xa7dro\xefdes"
    },
    {
        "bar": 35,
        "txt": "Sans feu\xa7 sans \xe2me"
    },
    {
        "bar": 36,
        "txt": "Sous o\xa7riflammes"
    },
    {
        "bar": 37,
        "txt": "C'est kitsch\xa7 pourtant"
    },
    {
        "bar": 38,
        "txt": "Les glitchs\xa7 d'\xe9crans"
    },
    {
        "bar": 39,
        "txt": "Restent me\xa7na\xe7ants"
    },
    {
        "bar": 40,
        "txt": "Omni\xa7pr\xe9sents"
    },
    {
        "bar": 42,
        "txt": ""
    },
    {
        "bar": 44,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 45,
        "txt": "Des symboles\xa7 des feux"
    },
    {
        "bar": 46,
        "txt": "Des croisements\xa7 du sang"
    },
    {
        "bar": 47,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 48,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 49,
        "txt": "Des symboles"
    },
    {
        "bar": 50,
        "txt": "Des feux\xa7 des croisements"
    },
    {
        "bar": 51,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 52,
        "txt": "Main gauche\xa7 le fil"
    },
    {
        "bar": 53,
        "txt": "De la rivi\xe8re\xa7 dessine"
    },
    {
        "bar": 54,
        "txt": "Des all\xe9es\xa7 des all\xe9es"
    },
    {
        "bar": 55,
        "txt": "Des all\xe9es\xa7 des all\xe9es"
    },
    {
        "bar": 56,
        "txt": "Main gauche\xa7 le fil"
    },
    {
        "bar": 57,
        "txt": "De la rivi\xe8re\xa7 dessine"
    },
    {
        "bar": 58,
        "txt": "Des all\xe9es\xa7 des all\xe9es"
    },
    {
        "bar": 59,
        "txt": "Des Allez\xa7 j'irai"
    },
    {
        "bar": 60,
        "txt": "danser\xa7 docile"
    },
    {
        "bar": 61,
        "txt": "Sous les arbres\xa7 mobiles"
    },
    {
        "bar": 62,
        "txt": "Torsion\xa7 clipping"
    },
    {
        "bar": 63,
        "txt": "Rotations\xa7 intimes"
    },
    {
        "bar": 64,
        "txt": "\xd4 folle\xa7 nature"
    },
    {
        "bar": 65,
        "txt": "Oh pour moi\xa7 dessine"
    },
    {
        "bar": 66,
        "txt": "Un tapis de\xa7 verdure"
    },
    {
        "bar": 67,
        "txt": "Aux pixels\xa7 acides"
    },
    {
        "bar": 69,
        "txt": ""
    },
    {
        "bar": 76,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 77,
        "txt": "Des symboles\xa7 des feux"
    },
    {
        "bar": 78,
        "txt": "Des croisements\xa7 du sang"
    },
    {
        "bar": 79,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 80,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 81,
        "txt": "Des symboles"
    },
    {
        "bar": 82,
        "txt": "Des feux\xa7 des croisements"
    },
    {
        "bar": 83,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 84,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 85,
        "txt": "Des symboles\xa7 des feux"
    },
    {
        "bar": 86,
        "txt": "Des croisements\xa7 du sang"
    },
    {
        "bar": 87,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 88,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 89,
        "txt": "Des symboles"
    },
    {
        "bar": 90,
        "txt": "Des feux\xa7 des croisements"
    },
    {
        "bar": 91,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 92,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 93,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 94,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 95,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 96,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 97,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 98,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 99,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 100,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 101,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 102,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 103,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 105,
        "txt": ""
    },
    {
        "bar": 107,
        "txt": "\xa7[L'orchestre est parti]"
    },
    {
        "bar": 109,
        "txt": ""
    },
    {
        "bar": 112,
        "txt": "\xa7[Forc\xe9ment]"
    },
    {
        "bar": 114,
        "txt": ""
    },
    {
        "bar": 116,
        "txt": "\xa7[Tout est vide]"
    },
    {
        "bar": 117,
        "txt": ""
    },
    {
        "bar": 118,
        "txt": "\xa7[Enfin]"
    },
    {
        "bar": 120,
        "txt": ""
    }
];
function $0cb3818ba656ff38$export$b3571188c770cc5a() {
    $0cb3818ba656ff38$var$karaokeText = document.getElementById("karatext");
    // Play signal sound
    $023aab51a0ce09ef$exports.play("karappo", {
        onended: ()=>{
            $0cb3818ba656ff38$var$clean();
        // TODO: EXIT ?
        }
    });
    $0cb3818ba656ff38$var$createKaraokeEvents();
}
function $0cb3818ba656ff38$var$createKaraokeEvents() {
    const beginAtBar = 0;
    $0cb3818ba656ff38$var$karaokeText.innerHTML = "&nbsp;";
    $0cb3818ba656ff38$var$karaokeData.forEach((d)=>{
        if (d.bar >= beginAtBar) {
            let from = 0;
            let to = 100;
            let dual = false;
            const time = d.bar * 2.4 + 2.4 - beginAtBar * 2.4;
            if (d.txt.includes($0cb3818ba656ff38$var$MARK) && d.txt[0] !== $0cb3818ba656ff38$var$MARK) {
                // This text includes a § marker, animate it in two parts
                dual = true;
                to = $0cb3818ba656ff38$var$getTextWidthPercentageBeforeMarker(d.txt, $0cb3818ba656ff38$var$karaokeText);
            }
            const cleanText = d.txt.replaceAll($0cb3818ba656ff38$var$MARK, "");
            // Handle no animation if MARK in on first char
            if (d.txt[0] == $0cb3818ba656ff38$var$MARK) to = 0;
            // Phase 1 (might be the only one)
            $0cb3818ba656ff38$var$timeouts.push(setTimeout(()=>{
                $0cb3818ba656ff38$var$karaokeText.innerHTML = `<span
                    data-text="${cleanText}"
                    style="
                        --karatext-animate-from: 0%;
                        --karatext-animate-to: ${to}%;
                    "
                >${cleanText || "&nbsp;"}</span>`;
            }, (time - 0.6) * 1000));
            // Phase 2 (only if marker present)
            if (dual) $0cb3818ba656ff38$var$timeouts.push(setTimeout(()=>{
                $0cb3818ba656ff38$var$karaokeText.innerHTML = `<span
                        data-text="${cleanText}"
                        style="
                            --karatext-animate-from: ${to}%;
                            --karatext-animate-to: 100%;
                        "
                    >${cleanText || "&nbsp;"}</span>`;
            }, (time + 0.6) * 1000));
        }
    });
}
// Source for getTextWidth(), getCssStyle() and getCanvasFont(): https://stackoverflow.com/a/21015393
function $0cb3818ba656ff38$var$getTextWidth(text, font) {
    // re-use canvas object for better performance
    const canvas = $0cb3818ba656ff38$var$getTextWidth.canvas || ($0cb3818ba656ff38$var$getTextWidth.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
}
function $0cb3818ba656ff38$var$getCssStyle(element, prop) {
    return window.getComputedStyle(element, null).getPropertyValue(prop);
}
function $0cb3818ba656ff38$var$getCanvasFont(el = document.body) {
    const fontWeight = $0cb3818ba656ff38$var$getCssStyle(el, "font-weight") || "normal";
    const fontSize = $0cb3818ba656ff38$var$getCssStyle(el, "font-size") || "16px";
    const fontFamily = $0cb3818ba656ff38$var$getCssStyle(el, "font-family") || "Times New Roman";
    return `${fontWeight} ${fontSize} ${fontFamily}`;
}
function $0cb3818ba656ff38$var$getTextWidthPercentageBeforeMarker(txt, element) {
    const font = $0cb3818ba656ff38$var$getCanvasFont(element);
    const textFragment = txt.substring(0, txt.indexOf($0cb3818ba656ff38$var$MARK));
    const cleanText = txt.replaceAll($0cb3818ba656ff38$var$MARK, "");
    const fragmentWidth = $0cb3818ba656ff38$var$getTextWidth(textFragment, font);
    const totalWidth = $0cb3818ba656ff38$var$getTextWidth(cleanText, font);
    return fragmentWidth / totalWidth * 100;
}
function $0cb3818ba656ff38$var$clearTimeouts() {
    $0cb3818ba656ff38$var$timeouts.forEach((t)=>clearTimeout(t));
}
function $0cb3818ba656ff38$var$clean() {
    $0cb3818ba656ff38$var$clearTimeouts();
    $0cb3818ba656ff38$var$karaokeText.innerHTML = "";
    $2044bad78f9935e8$export$51b36263b660c3ee(1);
}


// Development
window.DEVMODE = true;
// Config
window.LSI = 25; // Line Sequence Interval (Used in screen.sequence and unveil
// calls for line by line time interval in milliseconds)
function $42c1f3c961046928$var$init() {
    $52e181852859a5f5$export$2cd8252107eb640b();
    $52e181852859a5f5$export$471f7ae5c4103ae1("Initializing...");
    $2044bad78f9935e8$export$2cd8252107eb640b();
    $52e181852859a5f5$export$471f7ae5c4103ae1("Loading...");
    $caf37357c58d053a$export$2cd8252107eb640b().then(()=>{
        $52e181852859a5f5$export$4bb981a91e4f02eb();
    });
}
function $42c1f3c961046928$export$b3571188c770cc5a() {
    $0cb3818ba656ff38$export$b3571188c770cc5a();
}
$42c1f3c961046928$var$init();

})();
//# sourceMappingURL=index.ff8e23b9.js.map
